<h2 class="heading-4">Your {{ vm.claimType }}</h2>

<div class="divider mt-20 mb-20"></div>

<section class="grid">
  <section class="column">
    <h3 class="heading-5">Track your booking</h3>

    <section class="details flex flex-col gap-4">
      @if (vm.claim?.id) {
        <p class="body">Reference: {{ vm.claim.id }}</p>
      }
      @if (vm.claim?.fault) {
        <p class="body">Fault: {{ vm.claim.fault }}</p>
      }
    </section>

    <app-repair-tracker-timeline [claimType]="vm.claimType" />

    <div class="divider mt-12 mb-12"></div>

    <h3 class="heading-5">{{ vm.addressHeading }}</h3>

    <section class="address flex flex-col">
      @for (line of vm.address; track line) {
        <p class="body">
          {{ line }}
        </p>
      }
    </section>
  </section>
  <section class="column">
    <h3 class="heading-5" data-testid="sp-contact-heading">{{ vm.contactSection.heading }}</h3>

    <p class="body" data-testid="sp-contact-body">{{ vm.contactSection.body }}</p>

    @if (vm.contactSection.body2) {
      <p class="body" data-testid="sp-contact-body-2">{{ vm.contactSection.body2 }}</p>
    }

    <section class="contact flex-flex-col gap-8">
      <p class="body">
        {{ vm.claim?.serviceProvider?.name }}
      </p>

      <app-telephone-link
        [phoneNumber]="vm.claim?.serviceProvider?.phone"
        class="mt-8"
        [largeFont]="true"
        [postCode]="vm.postCode"
      >
        <app-contact-hours class="flex mt-12" [contactHours]="vm.contactHours" />
      </app-telephone-link>

      @if (vm.claim?.serviceProvider?.email) {
        <a class="other-links link-text mt-8 flex" [href]="'mailto:' + vm.claim.serviceProvider.email">
          <i class="fa-light fa-envelope mr-8"></i>
          <span>{{ vm.claim.serviceProvider.email }}</span>
        </a>
      }
    </section>

    <!--    <div class="divider mt-12 mb-12"></div>-->

    <!-- TODO: this needs updating to new approach -->
    <!-- TODO: Bring this back if it is agreed on approach to prevent capturing claims -->
    <!--    <app-feedback-collection area="repair-tracker" [id]="vm.claim.id" [config]="feedbackConfig" />-->
  </section>
</section>
